<!--
 * @Author: gaoxueting
 * @Date: 2020-06-11 09:49:59
 * @LastEditTime: 2020-08-06 15:32:53
 * @LastEditors: fengzhongmei
 * @Description:
 * @FilePath: /rightcloud-console2/src/views/modules/cloudmgt/env/components/acl/createrule.vue
-->
<template>
    <Modal v-model="modalCreate"
           :title="$t(this.title + '方向规则')"
           width="680"
           class="securitygroup-form"
           :mask-closable="false"
           @on-cancel="closeModal">
        <div class="rules-header">
            <div class="header-left">
                <div class="header-title">{{$t('规则策略')}}</div>
                <div>
                    <div class="rule-item"
                         v-for="item in action"
                         :key="item.id"
                         @click='changeAction(item)'
                         :class="selectAction.name === item.name? 'active':''">{{item.name}}</div>
                </div>
            </div>
            <div class="header-right">
                <div class="header-title">{{$t('规则协议')}}</div>
                <div>
                    <div class="rule-item"
                         v-for="item in rule.protocol"
                         :key="item.id"
                         @click='changeSelectRule(item)'
                         :class="selectRule.name === item.name? 'active' : '' ">{{item.name}}</div>
                </div>
            </div>
        </div>

        <Form ref="createForm"
              :model="formData"
              class="create-form"
              :rules="ruleForm"
              :label-width="120">
            <FormItem :label="`${$t('源地址')}:`"
                      prop="cidr">
                <InputNumber :max="255"
                             :min="0"
                             style="width: 70px"
                             v-model="formData.cidr0"></InputNumber>
                -
                <InputNumber :max="255"
                             :min="0"
                             style="width: 70px"
                             v-model="formData.cidr1"></InputNumber>
                -
                <InputNumber :max="255"
                             :min="0"
                             style="width: 70px"
                             v-model="formData.cidr2"></InputNumber>
                -
                <InputNumber :max="255"
                             :min="0"
                             style="width: 70px"
                             v-model="formData.cidr3"></InputNumber>
                /
                <InputNumber :max="32"
                             :min="0"
                             style="width: 70px"
                             v-model="formData.cidr4"></InputNumber>
                <Poptip trigger="hover"
                        placement="right"
                        :title="$t('远端地址')">
                    <i class="icon-prompt-1-o tips-style"
                       style="color:#4DA2EC"></i>
                    <div slot="content">
                        {{$t('允许通过该规则的ip地址（CIDR）')}}，<br />{{$t('填写0.0.0.0/0表示允许所有ip地址访问。')}}
                    </div>
                </Poptip>
                <div style="color: #ed4014">{{ oriCidrErr }}</div>
            </FormItem>
            <FormItem :label="`${$t('起始端口号')}:`"
                      v-if="['tcp','udp'].includes(selectRule.ipProtocol)"
                      class="form-label"
                      prop="oriFromPorts">
                <InputNumber :max="selectRule.ipProtocol=='ICMP'?255:65535"
                             :min="selectRule.ipProtocol=='ICMP'?0:1"
                             class="form-item"
                             v-model="formData.oriFromPorts"></InputNumber>
                <!--ICMP的端口范围是0-255其他的是1-65535 fixed bug 9050 by lcj-->
                <Poptip trigger="hover"
                        placement="right"
                        :content="selectRule.ipProtocol=='ICMP'? $t('端口范围') + '0~255':$t('端口范围') + '1~65535'">
                    <i class="icon-prompt-1-o tips-style"
                       style="color:#4DA2EC"></i>
                </Poptip>
                <p v-if="startPort"
                   style="color:#ed4014">{{$t('起始端口号不能小于1')}}</p>
            </FormItem>
            <FormItem :label="`${$t('终止端口号')}:`"
                      v-if="['tcp','udp'].includes(selectRule.ipProtocol)"
                      class="form-label"
                      prop="oriToPorts">
                <InputNumber :max="selectRule.ipProtocol=='ICMP'?255:65535"
                             :min="0"
                             class="form-item"
                             v-model="formData.oriToPorts"></InputNumber>
                <Poptip trigger="hover"
                        placement="right"
                        :content="selectRule.ipProtocol=='ICMP'?  $t('端口范围') + '0~255':$t('端口范围') + '2~65535'">
                    <i class="icon-prompt-1-o tips-style"
                       style="color:#4DA2EC"></i>
                </Poptip>
            </FormItem>
            <FormItem :label="`${$t('目的地址')}:`"
                      prop="cidr">
                <InputNumber :max="255"
                             :min="0"
                             style="width: 70px"
                             v-model="formData.cidr5"></InputNumber>
                -
                <InputNumber :max="255"
                             :min="0"
                             style="width: 70px"
                             v-model="formData.cidr6"></InputNumber>
                -
                <InputNumber :max="255"
                             :min="0"
                             style="width: 70px"
                             v-model="formData.cidr7"></InputNumber>
                -
                <InputNumber :max="255"
                             :min="0"
                             style="width: 70px"
                             v-model="formData.cidr8"></InputNumber>
                /
                <InputNumber :max="32"
                             :min="0"
                             style="width: 70px"
                             v-model="formData.cidr9"></InputNumber>
                <Poptip trigger="hover"
                        placement="right"
                        :title="$t('远端地址')">
                    <i class="icon-prompt-1-o tips-style"
                       style="color:#4DA2EC"></i>
                    <div slot="content">
                        {{$t('允许通过该规则的ip地址（CIDR）')}}，<br />{{$t('填写0.0.0.0/0表示允许所有ip地址访问。')}}
                    </div>
                </Poptip>
                <div style="color: #ed4014">{{ desCidrErr }}</div>
            </FormItem>
            <FormItem :label="`${$t('起始端口号')}:`"
                      v-if="['tcp','udp'].includes(selectRule.ipProtocol)"
                      class="form-label"
                      prop="desFromPorts">
                <InputNumber :max="selectRule.ipProtocol=='ICMP'?255:65535"
                             :min="selectRule.ipProtocol=='ICMP'?0:1"
                             class="form-item"
                             v-model="formData.desFromPorts"></InputNumber>
                <!--ICMP的端口范围是0-255其他的是1-65535 fixed bug 9050 by lcj-->
                <Poptip trigger="hover"
                        placement="right"
                        :content="selectRule.ipProtocol=='ICMP'? $t('端口范围') + '0~255':$t('端口范围') + '1~65535'">
                    <i class="icon-prompt-1-o tips-style"
                       style="color:#4DA2EC"></i>
                </Poptip>
                <p v-if="startPort"
                   style="color:#ed4014">{{$t('起始端口号不能小于1')}}</p>
            </FormItem>
            <FormItem :label="`${$t('终止端口号')}:`"
                      v-if="['tcp','udp'].includes(selectRule.ipProtocol)"
                      class="form-label"
                      prop="desToPorts">
                <InputNumber :max="selectRule.ipProtocol=='ICMP'?255:65535"
                             :min="0"
                             class="form-item"
                             v-model="formData.desToPorts"></InputNumber>
                <Poptip trigger="hover"
                        placement="right"
                        :content="selectRule.ipProtocol=='ICMP'?  $t('端口范围') + '0~255':$t('端口范围') + '2~65535'">
                    <i class="icon-prompt-1-o tips-style"
                       style="color:#4DA2EC"></i>
                </Poptip>
            </FormItem>
            <FormItem :label="`${$t('描述')}:`">
                <Input v-model="formData.description"
                       type="textarea"
                       :maxlength="225"
                       :autosize=" { minRows: 3, maxRows: 10 }"
                       style="width:476px" />
            </FormItem>
        </Form>
        <div class="submit"
             slot="footer">
            <Button @click="closeModal"
                    type="text"
                    style="margin-left: 8px">{{$t('取消')}}</Button>
            <Button type="primary"
                    @click="handleSubmit">{{title === '创建' ? $t('创建') : $t('保存')}}</Button>

        </div>
    </Modal>
</template>
<script>
import eventBus from '@/service/eventbus.js'
import API from '@/service/api.js'
export default {
    name: 'createrule',
    props: ['ruletype', 'direction', 'baseInfo'],
    computed: {
        range () {
            let r = ''
            if (this.selectRule.fromPort || this.selectRule.toPort) {
                r = this.selectRule.fromPort + '-' + this.selectRule.toPort
            } else {
                r = '-1--1'
            }
            return r
        }
    },
    data () {
        const validStopPort = (rule, value, callback) => {
            // if (!value) {
            //     callback(new Error('终止端口不能为空'))
            // } else
            if (value < this.formData.fromPorts) {
                callback(new Error('终止端口不能小于起始端口'))
            } else {
                callback()
            }
        }
        return {
            modalCreate: false,
            comparePort: false,
            startPort: false,
            title: '',
            ruleData: null,
            id: this.$route.params.id,
            envId: this.$route.query.envId,
            name: this.$route.query.name,
            oriCidrErr: '',
            desCidrErr: '',
            action: {
                allow: {
                    name: '允许',
                    value: 'allow'
                },
                deny: {
                    name: '拒绝',
                    value: 'deny'
                }
            },
            rule: {
                strategy: {

                },
                protocol: {
                    rule1:
                    {
                        id: 1,
                        name: 'TCP',
                        ipProtocol: 'tcp',
                        fromPort: '',
                        toPort: '',
                        portRange: true,
                        disPortRange: true
                    },
                    rule2:
                    {
                        id: 2,
                        name: 'UDP',
                        ipProtocol: 'udp',
                        fromPort: '1',
                        toPort: '65535',
                        portRange: true,
                        disPortRange: true
                    },
                    rule3:
                    {
                        id: 3,
                        name: 'ICMP',
                        ipProtocol: 'icmp',
                        fromPort: '1',
                        toPort: '65535',
                        portRange: true,
                        disPortRange: true
                    },
                    rule4:
                    {
                        id: 4,
                        name: '全部',
                        ipProtocol: 'all',
                        fromPort: '53',
                        toPort: '53',
                        disPortRange: true,
                        portRange: true
                    }
                }
            },
            selectRule: {
                id: 1,
                name: 'TCP',
                ipProtocol: 'tcp',
                portRange: false
            },
            selectAction: {
                name: '允许',
                value: 'allow'
            },
            formData: {
                cidr0: null,
                cidr1: null,
                cidr2: null,
                cidr3: null,
                cidr4: null,
                oriFromPorts: null,
                oriToPorts: null,
                cidr5: null,
                cidr6: null,
                cidr7: null,
                cidr8: null,
                cidr9: null,
                desFromPorts: null,
                desToPorts: null,
                description: ''
            },
            ruleForm: {
                oriFromPorts: [
                    { type: 'number', message: this.$t('该字段不能为空'), trigger: 'blur' }
                ],
                oriToPorts: [
                    { validator: validStopPort, type: 'number', trigger: 'blur' }
                ],
                desFromPorts: [
                    { type: 'number', message: this.$t('该字段不能为空'), trigger: 'blur' }
                ],
                desToPorts: [
                    { validator: validStopPort, type: 'number', trigger: 'blur' }
                ]
            }
        }
    },
    watch: {
        ruletype (newVal, oldVal) {
            switch (newVal) {
                case 'add':
                    this.title = '创建'
                    break
                case 'edit':
                    this.title = '编辑'
                    break
                case 'insertBefore':
                    this.title = '向前插入'
                    break
                case 'insertAfter':
                    this.title = '向后插入'
                    break
            }
            this.type = newVal
        },
        direction (newVal, oldVal) {
            this.Credirection = newVal
        },
        // 'formData.oriFromPorts' (val) {
        //     val && this.$refs.createForm.validateField('oriToPorts')
        // },
        // 'formData.desFromPorts' (val) {
        //     val && this.$refs.createForm.validateField('desToPorts')
        // },
        'selectRule.ipProtocol' (val) {
            if (val) {
                if (val !== 'ICMP' && this.formData.fromPorts <= 0 && this.formData.fromPorts !== null) {
                    this.startPort = true
                } else {
                    this.startPort = false
                }
            }
        }
    },
    methods: {
        openModal (row) {
            this.ruleData = row
            this.$refs.createForm.resetFields()
            this.comparePort = false
            if (row) {
                for (const item in this.protocol) {
                    for (const i in this.protocol[item]) {
                        if (i === 'ipProtocol') {
                            const ipProtocol = this.protocol[item][i]
                            if (row.protocol !== null) {
                                if (ipProtocol.toLowerCase() === row.protocol.toLowerCase()) {
                                    this.selectRule = this.protocol[item]
                                }
                            }
                        }
                    }
                }
            }
            this.modalCreate = true
            if (row) {
                this.selectAction.name = row.action === 'allow' ? '允许' : '拒绝'
                this.selectRule.name = row.protocol ? row.protocol.toUpperCase() : '全部'
                this.formData.description = row.description
                this.formData.oriFromPorts = row.sourcePort ? Number(row.sourcePort.split(':')[0]) : null
                this.formData.oriToPorts = row.sourcePort ? Number(row.sourcePort.split(':')[1]) : null
                this.formData.desFromPorts = row.targetPort ? Number(row.targetPort.split(':')[0]) : null
                this.formData.desToPorts = row.targetPort ? Number(row.targetPort.split(':')[1]) : null

                if (row.sourceUrl) {
                    const ad = row.sourceUrl.split('/')
                    const ipAdress = ad[0].split('.')
                    ipAdress.forEach((r, i) => {
                        this.formData['cidr' + i] = Number(r)
                    })
                    // 解决网络地址(::/0)出现的Nan
                    if (ipAdress.length === 1) {
                        ipAdress.forEach((r, i) => {
                            this.formData['cidr' + i] = null
                        })
                    }
                    this.formData.cidr4 = Number(ad[1])
                }
                if (row.targetUrl) {
                    const ad = row.targetUrl.split('/')
                    const ipAdress = ad[0].split('.')
                    ipAdress.forEach((r, i) => {
                        this.formData['cidr' + (i + 5)] = Number(r)
                    })
                    // 解决网络地址(::/0)出现的Nan
                    if (ipAdress.length === 1) {
                        ipAdress.forEach((r, i) => {
                            this.formData['cidr' + (i + 5)] = null
                        })
                    }
                    this.formData.cidr9 = Number(ad[1])
                }
            }
        },
        changeSelectAction (item) {
            this.$refs.createForm.resetFields()
            this.selectAction = item
        },
        changeAction (item) {
            this.selectAction = item
        },
        changeSelectRule (item) {
            this.$refs.createForm.resetFields()
            this.selectRule = item
        },
        closeModal () {
            this.formData = {
                cidr0: null,
                cidr1: null,
                cidr2: null,
                cidr3: null,
                cidr4: null,
                oriFromPorts: null,
                oriToPorts: null,
                cidr5: null,
                cidr6: null,
                cidr7: null,
                cidr8: null,
                cidr9: null,
                desFromPorts: null,
                desToPorts: null,
                description: ''
            }
            this.selectRule = {
                id: 1,
                name: 'TCP',
                ipProtocol: 'tcp',
                portRange: false
            }
            this.selectAction = {
                name: '允许',
                value: 'allow'
            }
            this.oriCidrErr = ''
            this.desCidrErr = ''
            this.handleReset()
        },
        handleReset () {
            this.$refs.createForm.resetFields()
            this.modalCreate = false
        },
        handleSubmit () {
            this.$refs.createForm.validate((valid) => {
                if (valid) {
                    this.oriCidrErr = ''
                    this.desCidrErr = ''
                    let oriHasCidr = true
                    let desHasCidr = true

                    if (['tcp', 'udp'].includes(this.selectRule.ipProtocol)) {
                        oriHasCidr = (this.formData.cidr0 || this.formData.cidr0 === 0) && (this.formData.cidr1 || this.formData.cidr1 === 0) && (this.formData.cidr2 || this.formData.cidr2 === 0) && (this.formData.cidr3 || this.formData.cidr3 === 0) && (this.formData.cidr4 || this.formData.cidr4 === 0)
                        !oriHasCidr && (this.oriCidrErr = this.$t('该字段不能为空'))

                        desHasCidr = (this.formData.cidr5 || this.formData.cidr5 === 0) && (this.formData.cidr6 || this.formData.cidr6 === 0) && (this.formData.cidr7 || this.formData.cidr7 === 0) && (this.formData.cidr8 || this.formData.cidr8 === 0) && (this.formData.cidr9 || this.formData.cidr9 === 0)
                        !desHasCidr && (this.desCidrErr = this.$t('该字段不能为空'))
                    }

                    const params = {
                        name: this.name,
                        cloudEnvId: this.envId,
                        action: this.selectAction.value,
                        protocol: this.selectRule.ipProtocol,
                        sourceUrl: (this.formData.cidr0 || 0) + '.' + (this.formData.cidr1 || 0) + '.' + (this.formData.cidr2 || 0) + '.' + (this.formData.cidr3 || 0) + '/' + (this.formData.cidr4 || 0),
                        sourcePortStart: this.formData.oriFromPorts,
                        sourcePortEnd: this.formData.oriToPorts,
                        targetUrl: (this.formData.cidr5 || 0) + '.' + (this.formData.cidr6 || 0) + '.' + (this.formData.cidr7 || 0) + '.' + (this.formData.cidr8 || 0) + '/' + (this.formData.cidr9 || 0),
                        targetPortStart: this.formData.desFromPorts,
                        targetPortEnd: this.formData.desToPorts,
                        description: this.formData.description
                    }
                    let axioType = ''
                    switch (this.type) {
                        case 'add':
                            axioType = 'post'
                            params.strategyUuid = this.direction === 'ingress' ? this.baseInfo.ingressFirewallPolicyId : this.baseInfo.egressFirewallPolicyId
                            break
                        case 'edit':
                            axioType = 'put'
                            params.id = this.ruleData.id
                            break
                        case 'insertBefore':
                            axioType = 'post'
                            params.insertBefore = this.ruleData.uuid
                            params.strategyUuid = this.direction === 'ingress' ? this.baseInfo.ingressFirewallPolicyId : this.baseInfo.egressFirewallPolicyId
                            break
                        case 'insertAfter':
                            axioType = 'post'
                            params.insertAfter = this.ruleData.uuid
                            params.strategyUuid = this.direction === 'ingress' ? this.baseInfo.ingressFirewallPolicyId : this.baseInfo.egressFirewallPolicyId
                            break
                    }
                    this.axios[axioType](this.urlFormat(API.POST_ACL_RULE, false), params).then(res => {
                        this.$emit('refreshTable')
                        this.closeModal()
                    })
                    this.modalCreate = false
                    this.handleReset()
                }
            })
        }
    },
    created () {
        const that = this
        eventBus.$on('setSecurityId', function (data) {
            that.securityId = data.securityId
            that.envId = data.envId
            that.pId = data.id
        })
    }
}
</script>
<style lang="less" scoped>
.securitygroup-form {
    font-family: 'PingFangSC-Light', 'Microsoft YaHei', '宋体', 'Helvetica Neue', Arial, Helvetica, sans-serif;
    .rules-header {
        display: flex;
        .header-left {
            display: inline-block;
            width: 40%;
        }
        .header-right {
            display: inline-block;
            flex: 1;
        }
        .header-title {
            padding-left: 25px;
            font-size: 16px;
        }
        .rule-item {
            display: inline-block;
            background: rgb(228, 243, 241);
            height: 40px;
            width: 130px;
            margin-top: 10px;
            margin-left: 25px;
            line-height: 40px;
            text-align: center;
            font-size: 13px;
            cursor: pointer;
        }
        .active {
            background-color: #3498dc;
            color: white;
        }
    }
    .create-form {
        margin-top: 20px;
        .form-label {
            display: inline-block;
            width: 48%;
            .form-item {
                width: 160px;
            }
        }
    }
}
</style>
